module.exports = __webpack_public_path__ + "img/logo-loader.e6a1602f.svg";